<template>
  <div>
    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Customer profile ready...</h3>
        </div>
      </div>
    </div>
    <div class="rider--main-content" v-else-if="staffDetails !== null">
      <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </div>
      <CModal
        v-show="isModalVisible"
        @close-delay="200"
        @close="closeModal"
        footer
        modalIsLarge
      >
        <template v-slot:title>
          <h2 class="fw-bold">Log Details</h2>
        </template>
        <template v-slot:body>
          <div v-if="log !== null">
            <div class="row mb-1">
              <div class="col-3 fw-bold">Action:</div>
              <div class="col-auto">{{ log.action }}</div>
            </div>
            <div class="row mb-1">
              <div class="col-3 fw-bold">User:</div>
              <div class="col-auto">
                {{ log.user.first_name }} {{ log.user.last_name }}<br>
                {{ log.user.username }}
              </div>
            </div>
            <div class="row mb-1">
              <div class=" form-group">
                <label for="" class=" fw-bold">Description</label>
                <textarea
                  name=""
                  class="form-control"
                  id=""
                  cols="30"
                  rows="5"
                  :value="log.description"
                  disabled
                  style="resize: none"
                ></textarea>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col-3 fw-bold">Created At:</div>
              <div class="col-auto">{{ log.created_at | date }}</div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button class=" btn btn-danger" @click.prevent="closeModal">
            Close
          </button>
        </template>
      </CModal>
      <h1 class="mt-2 mb-3 font-regular">
        {{ staffDetails.first_name }} {{ staffDetails.last_name }}'s Profile
      </h1>
      <div class="row mb-5">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Staff Profile
              </a>
            </li>

            <li class="nav-item" v-if="permissions.includes('audit-logs')">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Logs
              </a>
            </li>
          </CScrollbar>
        </div>
      </div>
      <div class="row" v-if="activetab === 1">
        <div class="col-auto mb-2">
          <button
            v-if="permissions.includes('reset-password-directly')"
            class="mt-2 btn btn-info"
            @click="resetPassword('password')"
            :disabled="rpLoading"
          >
            <span
              class="custom-loader"
              v-if="rpLoading"
            >
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Reset Password
            </span>
          </button>

          <button
            v-if="permissions.includes('reset-staff-fa')"
            class="mt-2 btn btn-info"
            @click="reset2FA()"
            :disabled="rpLoading1"
          >
            <span
              class="custom-loader"
              v-if="rpLoading1"
            >
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Reset 2FA &amp; Login PIN
            </span>
          </button>
        </div>
        <div
          class="col-12 mb-3"
          v-if="permissions.includes('update-staff')"
        >
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Allowed IP Addresses</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <p class="text-muted mb-3">
                  Add an IP address to allow this staff member to access the
                  admin panel outside the VPN. Entries expire after 5 hours.
                </p>
                <div class="row align-items-end">
                  <div class="col-md-6">
                    <div class="form-group mb-md-0">
                      <label for="ip_address">IP Address</label>
                      <input
                        id="ip_address"
                        type="text"
                        class="form-control"
                        v-model.trim="ipAddress"
                        placeholder="e.g. 192.168.1.10"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <button
                      type="button"
                      class="btn btn-info"
                      :disabled="twoFaLoading || !ipAddress"
                      @click="addAllowedIp"
                    >
                      <span class="custom-loader" v-if="twoFaLoading && twoFaAction === 'add-ip'">
                        <loader-icon size="1.5x" class="custom-class"></loader-icon>
                        <span style="font-weight: 600; text-transform: initial;"
                          >Adding IP...</span
                        >
                      </span>
                      <span v-else>Add IP Address</span>
                    </button>
                  </div>
                </div>
                <div class="mt-3" v-if="getAllowedIpsLoading">
                  <span class="text-muted">Loading allowed IPs...</span>
                </div>
                <div class="mt-3" v-else-if="allowedIps.length > 0">
                  <label class="fw-bold">Active Allowed IPs</label>
                  <ul class="list-group">
                    <li
                      class="list-group-item d-flex justify-content-between align-items-center"
                      v-for="ip in allowedIps"
                      :key="ip"
                    >
                      <span>{{ ip }}</span>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        :disabled="removingIp === ip || twoFaLoading"
                        @click="removeAllowedIp(ip)"
                      >
                        <span class="custom-loader" v-if="removingIp === ip">
                          <loader-icon size="1x" class="custom-class"></loader-icon>
                        </span>
                        <span v-else>Remove</span>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="mt-3" v-else>
                  <span class="text-muted">No allowed IP addresses yet.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Profile Information</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateStaffDetails">
                  <!-- General Information -->
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">General Information</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="full_name">First Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="staffDetails.first_name"
                          placeholder="Full Name"
                          name="firstname"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="last_name">Last Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="staffDetails.last_name"
                          placeholder="Full Name"
                          name="lastname"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="email_address">Email Address</label>
                        <input
                          type="email"
                          id="email_address"
                          class="form-control"
                          v-model.trim="staffDetails.email"
                          placeholder="Email Address"
                          name="email_address"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="phone_number">Phone Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="staffDetails.phone_number"
                          placeholder="Phone Number"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="referral_code">Referral Code</label>
                        <input
                          type="text"
                          class="form-control"
                          name="referral_code"
                          disabled
                          v-model.trim="staffDetails.referral_code"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Gender</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="staffDetails.gender"
                          disabled
                        >
                          <option value="male" class="mb-2">Male</option>
                          <option value="female" class="mb-2">Female</option>
                        </select>
                      </div>
                    </div> -->
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Role</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="staffDetails.role"
                        >
                          <option value="" disabled>Please Select</option>
                          <option
                            v-for="role in roles"
                            :value="role.name"
                            :key="role.id"
                          >
                            {{ role.name }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Status</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="staffDetails.profile_status"
                        >
                          <option value="active" class="mb-2">Active</option>

                          <option value="in-active" class="mb-2"
                            >Inactive</option
                          >
                        </select>
                      </div>
                    </div>
                    <!-- <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Referral Code</label> <br />
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="staffDetails.referral_code"
                          placeholder="Address"
                          name="address"
                          disabled
                        />
                      </div>
                    </div> -->
                  </div>

                  <button
                    type="submit"
                    class="button"
                    :disabled="
                      updateStaffLoading ||
                        !permissions.includes('update-staff')
                    "
                    :class="
                      permissions.includes('update-staff')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                  >
                    <span class="custom-loader" v-if="updateStaffLoading">
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;"
                        >Updating Staff...</span
                      >
                    </span>
                    <span v-else>Save Changes</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class=""
        v-if="
          activetab === 2 &&
            permissions.includes('audit-logs') &&
            logs.length > 0
        "
      >
        <div class="row align-items-end my-1" v-if="logs.length > 0">
          <div class="col-xl-3 col-lg-6 col-12 px--5">
            <div class="form-group">
              <label>Type</label>
              <select class="form-control" v-model="periodParams">
                <option value selected disabled>Please Select Period</option>
                <option value="range">Range</option>
                <option value="30-days">30-day</option>
                <option value="7-days">7-day</option>
              </select>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-12 px--5"
            v-if="periodParams === 'range'"
          >
            <div class="form-group">
              <label>Start Date</label>
              <input type="date" class="form-control" v-model="start_date" />
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-6 col-12 px--5"
            v-if="periodParams === 'range'"
          >
            <div class="form-group">
              <label>Stop Date</label>
              <input type="date" class="form-control" v-model="stop_date" />
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-12 px--5">
            <div class="form-group">
              <button @click.prevent="getLogs(1)" class=" btn button">
                <span v-if="loading" class="custom-loader">
                  <loader-icon size="1.5x" class="custom-class"></loader-icon>
                  <span style="font-weight: 600; text-transform: initial;"
                    >Please Wait</span
                  >
                </span>
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
        </div>
        <div class="card card--no-shadow">
          <div class="card-content">
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="logs"
                  :fields="fields"
                  :items-per-page="small ? 10 : 5"
                  pagination
                  sorter
                >
                  <template #user="{item}">
                    <td class="table--action-mobile">
                      {{ item.user.first_name }} {{ item.user.last_name }}
                    </td>
                  </template>
                  <template #created_at="{item}">
                    <td class="table--action-mobile">
                      {{ item.created_at | date }}
                    </td>
                  </template>
                  <template #actions="{item}">
                    <td class="table--action-mobile">
                      <button
                        class="button btn-success"
                        style="background-color: #0bc681;"
                        @click="showUpdateModal(item)"
                      >
                        View
                      </button>
                    </td>
                  </template>
                </CDataTable>
                <CPagination
                  :activePage.sync="next_page"
                  :pages="total"
                  :onActivePageChange="onPageChange()"
                ></CPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <two-factor-prompt
      :visible="showTwoFaPrompt"
      :loading="twoFaLoading"
      :description="twoFaDescription"
      :submit-label="twoFaSubmitLabel"
      :loading-text="twoFaLoadingText"
      @close="closeTwoFaPrompt"
      @submit="handleTwoFaSubmit"
    />
  </div>
</template>

<script>
import CScrollbar from "@/components/CScrollbar";

import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
import CModal from "@/components/CModal";
const fields = ["user", "action", "created_at", "actions"];

export default {
  name: "Staff",
  data() {
    return {
      fields,
      pageLoading: false,
      activetab: 1,
      modalIsLarge: true,
      staffDetails: null,
      roles: [],
      getRolesLoading: false,
      updateStaffLoading: false,
      periodParams: "",
      start_date: "",
      stop_date: "",
      next_page: 1,
      current: 1,
      total: 1,
      small: true,
      loading: true,
      isModalVisible: false,
      log: null,
      rpLoading: false,
      rpLoading1: false,
      ipAddress: "",
      allowedIps: [],
      getAllowedIpsLoading: false,
      removingIp: null,
      showTwoFaPrompt: false,
      twoFaLoading: false,
      twoFaAction: null,
      pendingIpAddress: null,
      resetType: "",
    };
  },
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    CDataTable,
    CPagination,
    CModal,
    CScrollbar
  },
  computed: {
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    twoFaDescription() {
      if (this.twoFaAction === "remove-ip") {
        return "Enter your authenticator code to remove this IP address.";
      }

      if (this.twoFaAction === "reset-password") {
        return "Enter your authenticator code to reset this staff member's password.";
      }

      if (this.twoFaAction === "reset-pin") {
        return "Enter your authenticator code to reset this staff member's pin.";
      }

      if (this.twoFaAction === "reset-2fa") {
        return "Enter your authenticator code to reset this staff member's 2FA and issue a new login PIN.";
      }

      return "Enter your authenticator code to add this IP address.";
    },
    twoFaLoadingText() {
      if (this.twoFaAction === "remove-ip") {
        return "Removing IP...";
      }

      if (
        this.twoFaAction === "reset-password" ||
        this.twoFaAction === "reset-pin" ||
        this.twoFaAction === "reset-2fa"
      ) {
        return "Processing...";
      }

      return "Adding IP...";
    },
    twoFaSubmitLabel() {
      if (this.twoFaAction === "remove-ip") {
        return "Remove IP";
      }

      if (this.twoFaAction === "reset-password") {
        return "Reset Password";
      }

      if (this.twoFaAction === "reset-pin") {
        return "Reset Pin";
      }

      if (this.twoFaAction === "reset-2fa") {
        return "Reset 2FA";
      }

      return "Add IP Address";
    },
  },
  methods: {
    async getStaffDetails() {
      try {
        this.pageLoading = true;
        const response = await ApiService.get(`user/view-staff/${this.slug}`);
        console.log(response);
        this.staffDetails = response.data.data;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error.response);
      }
    },
    async getAllRoles() {
      try {
        this.getRolesLoading = true;
        const response = await ApiService.get("user/roles");
        console.log(response.data.data);
        this.getRolesLoading = false;
        this.roles = response.data.data;
        // console.log(response)
      } catch (error) {
        this.getRolesLoading = false;
        console.log(error.response);
      }
    },
    async updateStaffDetails() {
      let data = {
        first_name: this.staffDetails.first_name,
        last_name: this.staffDetails.last_name,
        email: this.staffDetails.email,
        phone_number: this.staffDetails.phone_number,
        role: this.staffDetails.role,
        profile_status: this.staffDetails.profile_status
      };
      try {
        this.updateStaffLoading = true;
        const response = await ApiService.post(
          `user/update-staff/${this.slug}`,
          data
        );
        this.updateStaffLoading = false;
        console.log(response.data);
        Swal.fire({
          title: "Success",
          text: "Staff Updated Successfully",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
          confirmButtonText: "OK"
        });
      } catch (error) {
        console.log(error.response);
        this.updateStaffLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async showUpdateModal(item) {
      this.log = Object.assign({}, item);
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async getLogs(page) {
      try {
        const response = await ApiService.get(
          `settings/logs?page=${page}&user_id=${this.slug}&period=${this.periodParams}&start_date=${this.start_date}&stop_date=${this.stop_date}`
        );

        this.logs = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.pageLoading = false;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.pageLoading = false;
        console.log(error.response);
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.getLogs(this.next_page);
      }
    },
    async resetPassword(type) {
      const confirm = await Swal.fire({
        title: `Are you sure you want to perform this action`,
        showCancelButton: true,
        confirmButtonText: `Yes, Do it!`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      });

      if (!confirm.isConfirmed) return;

      this.resetType = type;
      this.twoFaAction = `reset-${type}`;
      this.showTwoFaPrompt = true;
    },
    async reset2FA() {
      const confirm = await Swal.fire({
        title: `Are you sure you want to Reset 2FA`,
        text:
          "This will disable authenticator 2FA and generate a new temporary login PIN for this staff member. The PIN will be sent by SMS and shown here so you can share it manually.",
        showCancelButton: true,
        confirmButtonText: `Yes, Do it!`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      });

      if (!confirm.isConfirmed) return;

      this.twoFaAction = "reset-2fa";
      this.showTwoFaPrompt = true;
    },
    async confirmReset2FA(code) {
      try {
        this.rpLoading1 = true;
        this.twoFaLoading = true;
        const response = await ApiService.post(`user/reset-fa/${this.slug}`, {
          code
        });
        this.rpLoading1 = false;
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();
        await this.showReset2FaResult(response.data);
        this.getStaffDetails();
      } catch (error) {
        this.rpLoading1 = false;
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    async showReset2FaResult(payload) {
      const loginPin =
        payload && payload.data && payload.data.login_pin
          ? payload.data.login_pin
          : "";
      const phoneNumber =
        payload && payload.data && payload.data.phone_number
          ? payload.data.phone_number
          : "";

      if (!loginPin) {
        Swal.fire({
          title: "Success",
          text: (payload && payload.message) || "2FA reset successful",
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        return;
      }

      const result = await Swal.fire({
        title: "2FA Reset Successful",
        html: `<p>A new temporary login PIN was generated for this staff member. It has been sent by SMS${
          phoneNumber ? ` to <strong>${phoneNumber}</strong>` : ""
        }. Copy it below if you need to send it manually.</p>
               <p style="font-size:22px;font-weight:700;letter-spacing:2px;margin-top:12px;user-select:all;">${loginPin}</p>
               <p style="margin-top:8px;color:#666;">This PIN is required for their next login before they set up 2FA again.</p>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Copy PIN",
        cancelButtonText: "Close",
        allowOutsideClick: false
      });

      if (result.isConfirmed) {
        const copied = await this.copyText(loginPin);
        Swal.fire({
          title: copied ? "Copied" : "Copy failed",
          text: copied
            ? "Login PIN copied to clipboard"
            : "Could not copy automatically. Please copy it from the previous screen.",
          icon: copied ? "success" : "info",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    async getAllowedIps() {
      if (!this.permissions.includes("view-staff")) {
        return;
      }

      try {
        this.getAllowedIpsLoading = true;
        const response = await ApiService.get(`user/allowed-ips/${this.slug}`);
        this.allowedIps = response.data.data.allowed_ips || [];
        this.getAllowedIpsLoading = false;
      } catch (error) {
        this.getAllowedIpsLoading = false;
        console.log(error.response);
      }
    },
    async addAllowedIp() {
      if (!this.ipAddress) {
        return;
      }

      this.twoFaAction = "add-ip";
      this.showTwoFaPrompt = true;
    },
    async removeAllowedIp(ip) {
      const confirm = await Swal.fire({
        title: "Remove IP address?",
        text: `Are you sure you want to remove ${ip}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, remove it",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",
        reverseButtons: true
      });

      if (!confirm.isConfirmed) {
        return;
      }

      this.pendingIpAddress = ip;
      this.twoFaAction = "remove-ip";
      this.showTwoFaPrompt = true;
    },
    closeTwoFaPrompt(force = false) {
      if (this.twoFaLoading && !force) {
        return;
      }

      this.twoFaLoading = false;
      this.showTwoFaPrompt = false;
      this.twoFaAction = null;
      this.pendingIpAddress = null;
    },
    async handleTwoFaSubmit(code) {
      if (this.twoFaAction === "add-ip") {
        await this.confirmAddAllowedIp(code);
      } else if (this.twoFaAction === "remove-ip") {
        await this.confirmRemoveAllowedIp(code);
      } else if (
        this.twoFaAction === "reset-password" ||
        this.twoFaAction === "reset-pin"
      ) {
        await this.confirmResetPassword(code);
      } else if (this.twoFaAction === "reset-2fa") {
        await this.confirmReset2FA(code);
      }
    },
    async confirmAddAllowedIp(code) {
      try {
        this.twoFaLoading = true;
        const response = await ApiService.post(`user/add-allowed-ip/${this.slug}`, {
          ip_address: this.ipAddress,
          code
        });

        this.allowedIps = response.data.data.allowed_ips || [];
        this.ipAddress = "";
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();

        Swal.fire({
          title: "Success",
          text: response.data.response_message || "IP address added successfully",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });
      } catch (error) {
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async confirmRemoveAllowedIp(code) {
      try {
        this.twoFaLoading = true;
        this.removingIp = this.pendingIpAddress;
        const response = await ApiService.post(`user/remove-allowed-ip/${this.slug}`, {
          ip_address: this.pendingIpAddress,
          code
        });

        this.allowedIps = response.data.data.allowed_ips || [];
        this.twoFaLoading = false;
        this.removingIp = null;
        this.closeTwoFaPrompt();

        Swal.fire({
          title: "Success",
          text: response.data.response_message || "IP address removed successfully",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });
      } catch (error) {
        this.removingIp = null;
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async copyText(text) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
          return true;
        }
      } catch (e) {
        // fall through to execCommand
      }

      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(el);
      return copied;
    },
    async showResetPasswordResult(payload) {
      const defaultPassword =
        payload && payload.data && payload.data.default_password
          ? payload.data.default_password
          : "";

      if (!defaultPassword) {
        Swal.fire({
          title: "Success",
          text: (payload && payload.message) || "Password reset successful",
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        return;
      }

      const result = await Swal.fire({
        title: "Password Reset Successful",
        html: `<p>Copy this default password and send it to the staff member. They must change it on first login.</p>
               <p style="font-size:22px;font-weight:700;letter-spacing:1px;margin-top:12px;user-select:all;">${defaultPassword}</p>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Copy Password",
        cancelButtonText: "Close",
        allowOutsideClick: false
      });

      if (result.isConfirmed) {
        const copied = await this.copyText(defaultPassword);
        Swal.fire({
          title: copied ? "Copied" : "Copy failed",
          text: copied
            ? "Password copied to clipboard"
            : "Could not copy automatically. Please copy it from the previous screen.",
          icon: copied ? "success" : "info",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    async confirmResetPassword(code) {
      try {
        this.rpLoading = true;
        this.twoFaLoading = true;
        const response = await ApiService.post(
          `customer/reset-${this.resetType}-directly/${this.slug}`,
          { code }
        );
        this.rpLoading = false;
        this.twoFaLoading = false;
        this.closeTwoFaPrompt();
        await this.showResetPasswordResult(response.data);
      } catch (error) {
        this.rpLoading = false;
        this.closeTwoFaPrompt(true);
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
  },
  mounted() {
    if (this.can("audit-logs")) {
      this.getLogs(1);
    }
    if (this.can("roles")) {
      this.getAllRoles();
    }
    this.getStaffDetails();
    this.getAllowedIps();
  }
};
</script>

<style scoped></style>
